<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter201shakehandsandmakepeace">CHAPTER 201 - SHAKE HANDS AND MAKE PEACE</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter202jointdemonification">CHAPTER 202 - JOINT DEMONIFICATION</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter203famoustibetansouth">CHAPTER 203 - FAMOUS TIBETAN SOUTH</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter204donotmentionitagain">CHAPTER 204 - DO NOT MENTION IT AGAIN</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter205proactivelyvisiting">CHAPTER 205 - PROACTIVELY VISITING</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter206takeglobalcontrol">CHAPTER 206 - TAKE GLOBAL CONTROL</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter207whatdoyouwantmetodo">CHAPTER 207 - WHAT DO YOU WANT ME TO DO</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter208farewellbydestiny">CHAPTER 208 - FAREWELL BY DESTINY</a>
</li>
<li class="table-of-content">
<a href="#/8_chapter209chineselilyflowerwithtongue">CHAPTER 209 - CHINESE LILY FLOWER WITH TONGUE</a>
</li>
<li class="table-of-content">
<span href="#/9_chapter210stirringuptherightandwrong" title="Link target outside of Sample">CHAPTER 210 - STIRRING UP THE RIGHT AND WRONG</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter211avoidingimportantsituationsandavoidingseriousproblems" title="Link target outside of Sample">CHAPTER 211 - AVOIDING IMPORTANT SITUATIONS AND AVOIDING SERIOUS PROBLEMS</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter212saviorsheart" title="Link target outside of Sample">CHAPTER 212 - SAVIOR'S HEART</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter213bodytest" title="Link target outside of Sample">CHAPTER 213 - BODY TEST</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter214phagocytosisofyangenergy" title="Link target outside of Sample">CHAPTER 214 - PHAGOCYTOSIS OF YANG ENERGY</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter215falsemouthgold" title="Link target outside of Sample">CHAPTER 215 - FALSE-MOUTH GOLD</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter216falsemouthgold" title="Link target outside of Sample">CHAPTER 216 - FALSE-MOUTH GOLD</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter217coverageasusual" title="Link target outside of Sample">CHAPTER 217 - COVERAGE AS USUAL</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter218carnage" title="Link target outside of Sample">CHAPTER 218 - CARNAGE</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter219fallingintothepathofdemons" title="Link target outside of Sample">CHAPTER 219 - FALLING INTO THE PATH OF DEMONS</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter220escapefromdeath" title="Link target outside of Sample">CHAPTER 220 - ESCAPE FROM DEATH</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter221appreciation" title="Link target outside of Sample">CHAPTER 221 - APPRECIATION</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter222pronunciation" title="Link target outside of Sample">CHAPTER 222 - PRONUNCIATION</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter223trackingtechnique" title="Link target outside of Sample">CHAPTER 223 - TRACKING TECHNIQUE</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter224completeobsession" title="Link target outside of Sample">CHAPTER 224 - COMPLETE OBSESSION</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter225therewassomethingdifferentabouttheperilousstar" title="Link target outside of Sample">CHAPTER 225 - THERE WAS SOMETHING DIFFERENT ABOUT THE PERILOUS STAR.</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter226whiterobedweirdo" title="Link target outside of Sample">CHAPTER 226 - WHITE-ROBED WEIRDO</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter227dissolvingthecrisis" title="Link target outside of Sample">CHAPTER 227 - DISSOLVING THE CRISIS</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter228sufferingretribution" title="Link target outside of Sample">CHAPTER 228 - SUFFERING RETRIBUTION</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter229whoiscontrolling" title="Link target outside of Sample">CHAPTER 229 - WHO IS CONTROLLING</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter230explainwhy" title="Link target outside of Sample">CHAPTER 230 - EXPLAIN WHY</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter231wishfulthinking" title="Link target outside of Sample">CHAPTER 231 - WISHFUL THINKING</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter232wideacceptanceofdisciples" title="Link target outside of Sample">CHAPTER 232 - WIDE ACCEPTANCE OF DISCIPLES</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter233letterofrepair" title="Link target outside of Sample">CHAPTER 233 - LETTER OF REPAIR</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter234keepalowprofile" title="Link target outside of Sample">CHAPTER 234 - KEEP A LOW PROFILE</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter235onestrokeofthehand" title="Link target outside of Sample">CHAPTER 235 - ONE STROKE OF THE HAND</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter236leapsandbounds" title="Link target outside of Sample">CHAPTER 236 - LEAPS AND BOUNDS</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter237stellarphenomenon" title="Link target outside of Sample">CHAPTER 237 - STELLAR PHENOMENON</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter238latenightcafeteria" title="Link target outside of Sample">CHAPTER 238 - LATE NIGHT CAFETERIA</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter239courtship" title="Link target outside of Sample">CHAPTER 239 - COURTSHIP</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter240witheringrain" title="Link target outside of Sample">CHAPTER 240 - WITHERING RAIN</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter241becomeangryfromembarrassment" title="Link target outside of Sample">CHAPTER 241 - BECOME ANGRY FROM EMBARRASSMENT</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter242craggyrock" title="Link target outside of Sample">CHAPTER 242 - CRAGGY ROCK</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter243stonegiant" title="Link target outside of Sample">CHAPTER 243 - STONE GIANT</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter244changeday" title="Link target outside of Sample">CHAPTER 244 - CHANGE DAY</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter245dismantlingofarms" title="Link target outside of Sample">CHAPTER 245 - DISMANTLING OF ARMS</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter246betweengainsandlosses" title="Link target outside of Sample">CHAPTER 246 - BETWEEN GAINS AND LOSSES</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter247pastandpresentlife" title="Link target outside of Sample">CHAPTER 247 - PAST AND PRESENT LIFE</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter248selfdeception" title="Link target outside of Sample">CHAPTER 248 - SELF-DECEPTION</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter249smallachievements" title="Link target outside of Sample">CHAPTER 249 - SMALL ACHIEVEMENTS</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter250sparring" title="Link target outside of Sample">CHAPTER 250 - SPARRING</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter251retreatintime" title="Link target outside of Sample">CHAPTER 251 - RETREAT IN TIME</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter252reminiscenceofthepast" title="Link target outside of Sample">CHAPTER 252 - REMINISCENCE OF THE PAST</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter253bemovedbythis" title="Link target outside of Sample">CHAPTER 253 - BE MOVED BY THIS</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter254mindpreservation" title="Link target outside of Sample">CHAPTER 254 - MIND PRESERVATION</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter255attacktheheartfortop" title="Link target outside of Sample">CHAPTER 255 - ATTACK THE HEART FOR TOP</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter256shinghuanling" title="Link target outside of Sample">CHAPTER 256 - SHINGHUANLING</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter257metaplasticspace" title="Link target outside of Sample">CHAPTER 257 - METAPLASTIC SPACE</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter258joyousnews" title="Link target outside of Sample">CHAPTER 258 - JOYOUS NEWS</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter259regroupingoftroopsandhorses" title="Link target outside of Sample">CHAPTER 259 - REGROUPING OF TROOPS AND HORSES</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter260armymeet" title="Link target outside of Sample">CHAPTER 260 - ARMY MEET</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter261preoccupation" title="Link target outside of Sample">CHAPTER 261 - PREOCCUPATION</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter262letterofwar" title="Link target outside of Sample">CHAPTER 262 - LETTER OF WAR</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter263spiderwebtrace" title="Link target outside of Sample">CHAPTER 263 - SPIDERWEB TRACE</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter264restaurantowner" title="Link target outside of Sample">CHAPTER 264 - RESTAURANT OWNER</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter265strongencounter" title="Link target outside of Sample">CHAPTER 265 - STRONG ENCOUNTER</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter266thebattleofthepeak" title="Link target outside of Sample">CHAPTER 266 - THE BATTLE OF THE PEAK</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter267commonenemy" title="Link target outside of Sample">CHAPTER 267 - COMMON ENEMY</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter268thunderrolling" title="Link target outside of Sample">CHAPTER 268 - THUNDER ROLLING</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter269poweroffaith" title="Link target outside of Sample">CHAPTER 269 - POWER OF FAITH</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter270womanlybenevolence" title="Link target outside of Sample">CHAPTER 270 - WOMANLY BENEVOLENCE</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter271traveltomale" title="Link target outside of Sample">CHAPTER 271 - TRAVEL TO MALE</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter272uneasiness" title="Link target outside of Sample">CHAPTER 272 - UNEASINESS</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter273tibetandoublewall" title="Link target outside of Sample">CHAPTER 273 - TIBETAN DOUBLE WALL</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter274intimatecomradeinarms" title="Link target outside of Sample">CHAPTER 274 - INTIMATE COMRADE-IN-ARMS</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter275envycranemystery" title="Link target outside of Sample">CHAPTER 275 - ENVY CRANE MYSTERY</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter276dismantlingpeople" title="Link target outside of Sample">CHAPTER 276 - DISMANTLING PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter277alllivingthingshaveemotions" title="Link target outside of Sample">CHAPTER 277 - ALL LIVING THINGS HAVE EMOTIONS</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter278temporarychangeofdivination" title="Link target outside of Sample">CHAPTER 278 - TEMPORARY CHANGE OF DIVINATION</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter279disclosure" title="Link target outside of Sample">CHAPTER 279 - DISCLOSURE</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter280siblingreaction" title="Link target outside of Sample">CHAPTER 280 - SIBLING REACTION</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter281twocutsofknife" title="Link target outside of Sample">CHAPTER 281 - TWO CUTS OF KNIFE</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter282itisdifficulttosay" title="Link target outside of Sample">CHAPTER 282 - IT IS DIFFICULT TO SAY</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter283reentryintothemilitary" title="Link target outside of Sample">CHAPTER 283 - REENTRY INTO THE MILITARY</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter284deathisenough" title="Link target outside of Sample">CHAPTER 284 - DEATH IS ENOUGH</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter285forcedlivelihood" title="Link target outside of Sample">CHAPTER 285 - FORCED LIVELIHOOD</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter286meetpeer" title="Link target outside of Sample">CHAPTER 286 - MEET PEER</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter287pyreticfever" title="Link target outside of Sample">CHAPTER 287 - PYRETIC FEVER</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter288subduingthedevilsnakes" title="Link target outside of Sample">CHAPTER 288 - SUBDUING THE DEVIL SNAKES</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter289deceit" title="Link target outside of Sample">CHAPTER 289 - DECEIT</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter290unrestrainedskeleton" title="Link target outside of Sample">CHAPTER 290 - UNRESTRAINED SKELETON</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter291goback" title="Link target outside of Sample">CHAPTER 291 - GO BACK</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter292identityexposure" title="Link target outside of Sample">CHAPTER 292 - IDENTITY EXPOSURE</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter293forrevenge" title="Link target outside of Sample">CHAPTER 293 - FOR REVENGE</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter294dragonawakening" title="Link target outside of Sample">CHAPTER 294 - DRAGON AWAKENING</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter295chapteriii" title="Link target outside of Sample">CHAPTER 295 - CHAPTER III</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter296inntalks" title="Link target outside of Sample">CHAPTER 296 - INN TALKS</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter297boredomintheheart" title="Link target outside of Sample">CHAPTER 297 - BOREDOM IN THE HEART</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter298finalharvest" title="Link target outside of Sample">CHAPTER 298 - FINAL HARVEST</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter299dreamagain" title="Link target outside of Sample">CHAPTER 299 - DREAM AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter300dreamscape" title="Link target outside of Sample">CHAPTER 300 - DREAMSCAPE</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2b547f62